<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import clench from '@/assets/animations/clench.json';

export default {
  name: 'Clench',
  mixins: [animation],
  data: () => ({
    animationData: clench,
    autoPlay: true,
  }),
};
</script>

<style lang="scss" scoped>
.animation {
  position: absolute;
  width: 330%;
  top: 34%;
  margin-left: 2%;
}
</style>
